import {Colors} from "../colors";
import React, {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Dimensions, View} from "react-native";
import {ProductItemStyles} from "../styles";
import Text from "./Text";


const NoProductItem = React.memo(() => {

    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    const windowWidth = Dimensions.get('window').width;
    const lStyles = ProductItemStyles(colors);

    return <View style={lStyles.mainContainer}>

            <View style={lStyles.noProductItem}>
                <Text>درحال حاضر محصولی در این بخش وجود ندارد!</Text>
            </View>

        </View>
});


export default NoProductItem;